export default __webpack_public_path__ + "static/media/back-arrow.7e0aad6a.svg";